export enum RulesEngineActionTypeEnum {
    Notification = 1,
    DiagnositicEvent = 2,
    SetTagValue = 3,
    Report = 4
}